import { FC, memo, ReactNode } from 'react'
import Barcode from 'react-barcode'
import cn from 'classnames'
import { OrderItem } from 'src/schema'

interface OrderYarcheAcceptedProps {
  barcode: string
  status: OrderItem.Status
  className?: string
}

interface StepItemProps {
  children: ReactNode
  stepNumber: number
  hasBorder?: boolean
  hasOffset?: boolean
}

const StepItem: FC<StepItemProps> = ({ children, stepNumber, hasBorder = true, hasOffset = true }) => (
  <li
    className={cn(
      hasBorder &&
        'before:absolute before:left-[0.6786em] before:mt-5 before:block before:h-[calc(100%_+_16px)] before:w-px before:bg-outline',
      hasOffset && 'mb-6',
      'relative pl-9'
    )}
  >
    <div className="absolute left-0 top-0 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-on-surface text-body-sm text-surface">
      {stepNumber}
    </div>
    {children}
  </li>
)

const StatusTitle: FC<{ status: OrderItem.Status }> = ({ status }) => {
  if (status === OrderItem.Status.DELIVERED) {
    return <div className="text-title-lg">Спасибо, заявка исполнена!</div>
  }

  if (status !== OrderItem.Status.NEW && status !== OrderItem.Status.DESTINATION_TERMINAL) {
    return <div className="text-title-lg">Спасибо, заявка обработана!</div>
  }

  return null
}

const NewStatusContent: FC<{ barcode: string }> = ({ barcode }) => (
  <ol className="relative list-none text-body-md">
    <StepItem stepNumber={1}>Ожидаем вас с паспортом в выбранном магазине для передачи груза.</StepItem>
    <StepItem stepNumber={2}>
      Назовите кассиру номер заявки или покажите код с экрана:{' '}
      <Barcode background="transparent" format="EAN13" value={barcode} />
    </StepItem>
    <StepItem hasBorder={false} hasOffset={false} stepNumber={3}>
      Передайте груз и предъявите паспорт. Кассир назовет конечную стоимость для оплаты.
    </StepItem>
  </ol>
)

const DestinationTerminalContent: FC<{ barcode: string }> = ({ barcode }) => (
  <ol className="relative list-none text-body-md">
    <StepItem stepNumber={1}>Ожидаем вас в выбранном магазине для получения груза.</StepItem>
    <StepItem stepNumber={2}>
      Назовите кассиру номер заявки или покажите код с экрана:{' '}
      <Barcode background="transparent" format="EAN13" value={barcode} />
    </StepItem>
    <StepItem hasBorder={false} hasOffset={false} stepNumber={3}>
      Вам придет СМС с кодом. Назовите кассиру код из сообщения.
    </StepItem>
  </ol>
)

const OrderYarcheAccepted: FC<OrderYarcheAcceptedProps> = ({ barcode, className, status }) => (
  <div className={cn(className, 'rounded-xl bg-surface2 p-3')}>
    <StatusTitle status={status} />

    {status === OrderItem.Status.NEW && <NewStatusContent barcode={barcode} />}

    {status === OrderItem.Status.DESTINATION_TERMINAL && <DestinationTerminalContent barcode={barcode} />}
  </div>
)

export default memo(OrderYarcheAccepted)
